(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-lob-kritik"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var root = document.querySelector('[data-ml-lob-kritik]');
    if (!root || root.dataset.mlLkInit) return;
    root.dataset.mlLkInit = '1';

    var form = document.getElementById('lk-form');
    if (!form) return;

    /* ── Vorbelegung aus den Klaviyo-Parametern (?stars/order/email/name) ── */
    var p = new URLSearchParams(window.location.search);
    function setz(id, wert) {
      var el = document.getElementById(id);
      if (el && wert) el.value = wert;
    }
    setz('lk-name', p.get('name'));
    setz('lk-email', p.get('email'));
    setz('lk-order', p.get('order'));

    var sterne = p.get('stars');
    if (sterne) {
      var s = document.getElementById('lk-sterne');
      if (s) s.value = sterne + ' von 5';
    }

    /* ── TP-Marker: Besucher kam über die Bewertungsmail ────────────────
       Herkunft = URL trägt die Klaviyo-Params (?stars und/oder ?order).
       Dann bekommt contact[Quelle] den Zusatz " (TP)" für die
       Gorgias-Zuordnung. Ohne JS bleibt die Quelle ohne Marker. */
    var quelle = document.getElementById('lk-quelle');
    if (quelle) {
      var ausMail = !!(sterne || (p.get('order') || '').trim());
      if (ausMail && quelle.value.indexOf(' (TP)') === -1) {
        quelle.value += ' (TP)';
      }
    }

    /* ── Absende-Checks (Komfort; ohne JS greift das native required) ──── */
    var text = document.getElementById('lk-text');

    form.addEventListener('submit', function (e) {
      /* Honeypot: wurde das unsichtbare Fax-Feld befüllt, war es ein Bot ->
         Versand still blocken. Bots OHNE JavaScript werden hier NICHT
         gefangen (Shopify wertet das Feld serverseitig nicht aus) —
         Backstop ist eine Gorgias-Regel auf die "Fax:"-Zeile in der Mail. */
      var hp = document.getElementById('lk-hp');
      if (hp && hp.value) {
        e.preventDefault();
        return;
      }

      if (text) {
        var inhalt = (text.value || '').trim();
        var fehler = document.getElementById('lk-text-fehler');

        if (inhalt.length < 5) {
          e.preventDefault();
          text.classList.add('lk--invalid');
          if (fehler) fehler.classList.add('is-on');
          text.focus();
        }
      }
    });

    if (text) {
      text.addEventListener('input', function () {
        text.classList.remove('lk--invalid');
        var fehler = document.getElementById('lk-text-fehler');
        if (fehler) fehler.classList.remove('is-on');
      });
    }

    /* ── Nach erfolgreichem Versand zum Danke-Block scrollen ───────────── */
    if (window.location.hash === '#contact_form' || root.querySelector('.lk__danke')) {
      var danke = root.querySelector('.lk__danke');
      if (danke) danke.scrollIntoView({ block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlp-explosionszeichnung"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ezReady) return; root.dataset.ezReady = '1';
      var read = function (sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } };
      var teile = read('[data-ez-teile]') || [];
      var hotspots = read('[data-ez-hotspots]') || [];
      var products = read('[data-ez-products]') || {};
      var layer = root.querySelector('[data-hotspots]');
      var tbody = root.querySelector('[data-list]');
      var canvas = root.querySelector('.ez__canvas');
      var zoom = 1;

      hotspots.forEach(function (h) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ez__hs'; b.dataset.pos = h[0];
        b.style.left = h[1] + '%'; b.style.top = h[2] + '%';
        b.style.width = h[3] + '%'; b.style.height = h[4] + '%';
        b.setAttribute('aria-label', 'Position ' + h[0]);
        b.addEventListener('click', function () { select(h[0], true); });
        layer.appendChild(b);
      });

      function rowHtml(t, p) {
        var name = p ? '<a href="' + p.url + '">' + esc(p.title) + '</a>' : esc(t.name);
        var img = p && p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '';
        var btn = p && p.available
          ? '<button type="button" class="ez__add" data-variant="' + p.variant + '">In den Warenkorb</button>'
          : '<span class="ez__soldout">' + (p ? 'nicht verfügbar' : 'nicht im Shop') + '</span>';
        return '<td class="ez__pos">' + esc(t.pos) + '</td>' +
          '<td><div class="ez__part">' + img + '<div>' + name + '<span class="ez__sku">Art.-Nr. ' + esc(t.sku) + '</span></div></div></td>' +
          '<td class="ez__num">' + (t.menge || '') + '</td>' +
          '<td class="ez__num">' + (p ? p.price : '') + '</td>' +
          '<td class="ez__num">' + btn + '</td>';
      }

      /* Fix C4: Die Zeilen kommen serverseitig aus Liquid — hier nur noch
         Hover-Kopplung an die Hotspots (Delegation statt Listener je Zeile). */
      tbody.addEventListener('mouseover', function (e) {
        var tr = e.target.closest('tr.ez__row');
        if (tr && tr.dataset.pos) mark(tr.dataset.pos);
      });

      /* Liquid liefert aus der Metaobject-Produktliste nur die ersten 50
         Referenzen — Server-Zeilen mit data-hydrate (Teile ohne aufgelöstes
         Produkt) werden GEBÜNDELT nachgeladen (AAUFTRAG C4): eine
         Section-Rendering-Abfrage /search?q=variants.sku:… OR … je bis zu
         40 Teilenummern statt einer Abfrage pro Teil. Die Section liefert
         im Search-Kontext die Produkt-Map (Preis-HTML aus ml-upset-price,
         identisch zum Server-Rendering, Netto-Schalter-kompatibel). */
      (function hydrateMissing() {
        var rootUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        var missing = teile.filter(function (t) {
          return !products[String(t.pid)] &&
            tbody.querySelector('tr[data-sku="' + CSS.escape(t.sku) + '"][data-hydrate]');
        });
        if (!missing.length) return;
        var apply = function (chunk) {
          chunk.forEach(function (t) {
            var p = products[String(t.pid)];
            if (!p) return;
            tbody.querySelectorAll('tr[data-sku="' + CSS.escape(t.sku) + '"][data-hydrate]').forEach(function (tr) {
              tr.innerHTML = rowHtml(t, p);
              tr.removeAttribute('data-hydrate');
            });
          });
        };
        for (var i = 0; i < missing.length; i += 40) {
          (function (chunk) {
            var q = chunk.map(function (t) {
              return 'variants.sku:"' + String(t.sku).replace(/"/g, '') + '"';
            }).join(' OR ');
            fetch(rootUrl + 'search?section_id=' + encodeURIComponent(root.dataset.section) +
                  '&type=product&q=' + encodeURIComponent(q))
              .then(function (r) { return r.ok ? r.text() : null; })
              .then(function (html) {
                if (!html) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var el = doc.querySelector('[data-ez-hydrate]');
                if (!el) return;
                var map = JSON.parse(el.textContent);
                Object.keys(map).forEach(function (k) { products[k] = map[k]; });
                apply(chunk);
              })
              .catch(function () {});
          })(missing.slice(i, i + 40));
        }
      })();

      tbody.addEventListener('click', function (e) {
        var b = e.target.closest('.ez__add'); if (!b) return;
        b.disabled = true; var label = b.textContent; b.textContent = '…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(b.dataset.variant), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            b.textContent = '✓ Hinzugefügt';
            // Horizon-Standard-Event (shopify:cart:lines-update, action "add"):
            // öffnet den Warenkorb-Drawer (auto-open), aktualisiert den
            // Header-Zähler (cart-icon liest cart.totalQuantity) und lässt den
            // Drawer-Inhalt neu rendern (ohne sections-HTML im promise-Detail
            // refetcht cart-items seine Section selbst).
            var rootUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
            fetch(rootUrl + 'cart.js')
              .then(function (r) { return r.json(); })
              .catch(function () { return null; })
              .then(function (cart) {
                var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true, composed: true });
                evt.action = 'add';
                evt.context = 'product';
                evt.lines = [{ merchandiseId: String(b.dataset.variant), quantity: 1 }];
                evt.promise = Promise.resolve({
                  cart: cart ? { totalQuantity: cart.item_count } : undefined,
                  detail: { source: 'explosionszeichnung', itemCount: cart ? cart.item_count : 1 }
                });
                b.dispatchEvent(evt);
              });
            setTimeout(function () { b.textContent = label; b.disabled = false; }, 2000);
          })
          .catch(function () { b.textContent = 'Fehler'; setTimeout(function () { b.textContent = label; b.disabled = false; }, 2000); });
      });

      root.querySelector('[data-filter]').addEventListener('input', function (e) {
        var q = e.target.value.trim().toLowerCase();
        tbody.querySelectorAll('tr').forEach(function (tr) { tr.hidden = q && tr.dataset.search.indexOf(q) === -1; });
      });

      root.querySelectorAll('[data-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          zoom = Math.min(4, Math.max(1, zoom + (b.dataset.zoom === 'in' ? .5 : -.5)));
          canvas.style.setProperty('--ez-zoom', zoom);
          /* AAUFTRAG C4: höhere Auflösung erst beim Zoomen nachladen —
             initial lädt die Zeichnung max. 2400px. */
          if (zoom > 1 && !root.dataset.ezHires) {
            root.dataset.ezHires = '1';
            var im = root.querySelector('.ez__img');
            if (im && im.src) {
              im.srcset = ''; im.removeAttribute('sizes');
              im.src = im.src.replace(/([?&]width=)\d+/, '$13840');
            }
          }
        });
      });

      function mark(pos) {
        root.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
        root.querySelectorAll('[data-pos="' + CSS.escape(pos) + '"]').forEach(function (el) { el.classList.add('is-active'); });
      }
      function select(pos, scroll) {
        mark(pos);
        var row = tbody.querySelector('tr[data-pos="' + CSS.escape(pos) + '"]');
        if (row && scroll) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    }
    function boot() { document.querySelectorAll('.ez[data-section]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
